import React from 'react';
import Navbar from '../Homepage/Navbar';
import Footer from '../Homepage/Footer';

const Contact = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-grow pt-32 pb-20 bg-dark-secondary">
                <div className="max-w-2xl mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-12 text-center">Contact <span className="text-nvcti-orange">Us</span></h1>
                    <div className="bg-dark-tertiary p-10 rounded-3xl shadow-2xl border border-white/5 space-y-10 backdrop-blur-md">
                        <div className="flex items-start gap-6 border-b border-white/5 pb-8">
                            <div className="w-12 h-12 bg-nvcti-orange/10 rounded-xl flex items-center justify-center text-2xl">📍</div>
                            <div>
                                <h3 className="text-xl font-bold text-white mb-2">Address</h3>
                                <p className="text-gray-400 leading-relaxed">
                                    NVCTI, 2nd Floor, i2h Building, IIT (ISM) Dhanbad, Jharkhand, India 826004
                                </p>
                            </div>
                        </div>
                        <div className="flex items-start gap-6 border-b border-white/10 pb-8">
                            <div className="w-12 h-12 bg-accent-primary/10 rounded-xl flex items-center justify-center text-2xl">📧</div>
                            <div>
                                <h3 className="text-xl font-bold text-white mb-2">Email</h3>
                                <a href="mailto:nvcti@iitism.ac.in" className="text-accent-primary font-bold text-lg hover:underline transition-all cursor-pointer block">nvcti@iitism.ac.in</a>
                            </div>
                        </div>
                        <div className="flex items-start gap-6">
                            <div className="w-12 h-12 bg-green-500/10 rounded-xl flex items-center justify-center text-2xl">📞</div>
                            <div>
                                <h3 className="text-xl font-bold text-white mb-2">Phone</h3>
                                <a href="tel:7707018426" className="text-green-500 font-bold text-lg hover:underline transition-all cursor-pointer block">7707018426</a>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default Contact;
